export default __webpack_public_path__ + "static/media/example_background.18cde311.png";